import { Route, Routes } from "react-router-dom";
import { Routes as FleetFireExtinguisherRoutes } from "./routes";
import { FleetFireExtinguisherRouterCmp } from "./types";
import { FireExtinguisherSearchPage } from "../pages/FireExtinguisherSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetFireExtinguisherRouter: FleetFireExtinguisherRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={FireExtinguisherSearchPage.route}
          element={<FireExtinguisherSearchPage />}
        />
      </Routes>
    </>
  );
};

FleetFireExtinguisherRouter.route =
  FleetFireExtinguisherRoutes.FleetFireExtinguisherRouter;

export default FleetFireExtinguisherRouter;
